import {
	Component,
	EventEmitter,
	Input,
	Output
}                           from '@angular/core';
import { IChipChangeEvent } from '@shared/components/chip/chip.model';

@Component( {
	selector: 'app-chip-item[name][id]',
	templateUrl: './chip-item.component.html',
	styleUrls: [ './chip-item.component.scss' ]
} )
export class ChipItemComponent {

	@Input() id: string;
	@Input() isDisabled = false;
	@Input() isHidden = false;
	@Input() isRenderable = true;
	@Input() isSelected = false;
	@Input() name: string;

	@Output() changeEmitter: EventEmitter<IChipChangeEvent> = new EventEmitter<IChipChangeEvent>();

	onClick() {
		this.isSelected = !this.isSelected;

		const chipChangeEvent: IChipChangeEvent = {
			id: this.id,
			isSelected: this.isSelected
		};

		this.changeEmitter.emit( chipChangeEvent );
	}
}
